import { combineReducers } from 'redux-immutable';

import { ImmutableInterface } from '../types/';

import AccountReducer from './AccountReducer/AccountReducer';
import { BaseAccountStoreProps } from './AccountReducer/AccountReducer.types';
import AgreementsReducer from './AgreementsReducer/AgreementsReducer';
import AlphasReducer from './AlphasReducer/AlphasReducer';
import { BaseAlphasStore } from './AlphasReducer/AlphasReducer.types';
import { AlphaListsReducer } from './AlphaListsReducer/AlphaListsReducer';
import { BaseAlphaListStore, BaseAlphaTagsStore } from './AlphaListsReducer/AlphaListsReducer.types';
import AlphaPropertiesReducer from './AlphaPropertiesReducer/AlphaPropertiesReducer';
import { BaseAlphaPropertiesStore } from './AlphaPropertiesReducer/AlphaPropertiesReducer.types';
import AuthenticationReducer from './AuthenticationReducer/AuthenticationReducer';
import { BaseAuthenticationStore } from './AuthenticationReducer/AuthenticationReducer.types';
import CompetitionsReducer from './CompetitionsReducer/CompetitionsReducer';
import { BaseCompetitionsStore } from './CompetitionsReducer/CompetitionsReducer.types';
import ConsultantReducer from './ConsultantReducer/ConsultantReducer';
import { BaseConsultantStore } from './ConsultantReducer/ConsultantReducer.types';
import CustomFiltersReducer from './CustomFilters/CustomFiltersReducer';
import { BaseCustomFiltersStoreProps } from './CustomFilters/CustomFiltersReducer.types';
import { BaseDashboardStore, DashboardReducer } from './DashboardReducer';
import editorReducer from './EditorReducer/EditorReducer';
import { BaseEditorStore } from './EditorReducer/EditorReducer.types';
import { BaseEventsStore, EventsReducer } from './Events';
import { ExpressionLanguageReducer } from './ExpressionLanguageReducer/ExpressionLanguageReducer';
import { BaseExpressionLanguageStore } from './ExpressionLanguageReducer/ExpressionLanguageReducer.types';
import { FastExpressionLanguageReducer } from './FastExpressionLanguageReducer/FastExpressionLanguageReducer';
import { BaseFastExpressionLanguageStore } from './FastExpressionLanguageReducer/FastExpressionLanguageReducer.types';
import FlashMessageReducer from './FlashMessageReducer/FlashMessageReducer';
import { BaseFlashMessagesStore } from './FlashMessageReducer/FlashMessageReducer.types';
import { LanguageFieldsReducer } from './LanguageFieldsReducer/LanguageFieldsReducer';
import { BaseLanguageFieldsStore } from './LanguageFieldsReducer/LanguageFieldsReducer.types';
import { LeaderboardReducer } from './LeaderboardReducer/LeaderboardReducer';
import { BaseLeaderboardStore } from './LeaderboardReducer/LeaderboardReducer.types';
import { BaseLearnStore, LearnReducer } from './LearnReducer';
import MessagesReducer from './MessagesReducer/MessagesReducer';
import { BaseMessagesStore } from './MessagesReducer/MessagesReducer.types';
import { BaseProfileStore, ProfileReducer } from './ProfileReducer';
import { BaseAgreementsStoreProps } from './ProfileReducer/AgreementsReducer/AgreementsReducer.types';
import { BaseSimulationStore, SimulationReducer } from './SimulationReducer';
import { BaseTeamStore, TeamReducer } from './TeamReducer';
import { AccountWizardReducer } from './AccountReducer/AccountWizardReducer';
import { BaseAccountWizardStoreProps } from './AccountReducer/AccountWizardReducer.types';
import { BaseCaptchaStoreProps, captchaReducer } from './CaptchaReducer/CaptchaReducer';
import { BaseGeniusStoreProps, geniusReducer } from './GeniusProgramReducer/GeniusReducer';
import { BaseTutorialStoreProps, tutorialReducer } from './TutorialReducer/TutorialReducer';
import { BaseTutorialStore, consultantTutorialReducer } from './ConsultantTutorialReducer/ConsultantTutorialReducer';
import { BaseCustomPreferencesStore, customPreferencesReducer } from './CustomPreferencesReducer/CustomPreferencesReducer';

const tagsReducer = combineReducers<BaseAlphaListStore>({
  lists: AlphaListsReducer,
});

const combinedStore = combineReducers<BaseStoreTypes>({
  alphas: AlphasReducer,
  alphaProperties: AlphaPropertiesReducer,
  competitions: CompetitionsReducer,
  editor: editorReducer,
  dashboard: DashboardReducer,
  expression: ExpressionLanguageReducer,
  fast_expression: FastExpressionLanguageReducer,
  language_fields: LanguageFieldsReducer,
  flashMessages: FlashMessageReducer,
  profile: ProfileReducer,
  simulation: SimulationReducer,
  user: AuthenticationReducer,
  team: TeamReducer,
  messages: MessagesReducer,
  events: EventsReducer,
  agreements: AgreementsReducer,
  customFilters: CustomFiltersReducer,
  account: AccountReducer,
  accountWizard: AccountWizardReducer,
  leaderboard: LeaderboardReducer,
  learn: LearnReducer,
  tags: tagsReducer,
  consultant: ConsultantReducer,
  captcha: captchaReducer,
  genius: geniusReducer,
  tutorial: tutorialReducer,
  consultantTutorial: consultantTutorialReducer,
  customPreferences: customPreferencesReducer,
});

export type BaseStoreTypes = BaseAlphasStore &
  BaseAlphaPropertiesStore &
  BaseCompetitionsStore &
  BaseEditorStore &
  BaseDashboardStore &
  BaseExpressionLanguageStore &
  BaseFastExpressionLanguageStore &
  BaseLanguageFieldsStore &
  BaseFlashMessagesStore &
  BaseProfileStore &
  BaseSimulationStore &
  BaseAuthenticationStore &
  BaseTeamStore &
  BaseMessagesStore &
  BaseEventsStore &
  BaseAgreementsStoreProps &
  BaseCustomFiltersStoreProps &
  BaseAccountStoreProps &
  BaseLeaderboardStore &
  BaseLearnStore &
  BaseAlphaTagsStore &
  BaseConsultantStore &
  BaseAccountWizardStoreProps &
  BaseCaptchaStoreProps &
  BaseGeniusStoreProps &
  BaseTutorialStoreProps & {
    consultantTutorial: BaseTutorialStore;
    customPreferences: BaseCustomPreferencesStore;
  };

export type StateType = ImmutableInterface<BaseStoreTypes>;

export { combinedStore };
